export default "__VITE_ASSET__Bno5j1Ez__"